module.exports = __webpack_public_path__ + "media/img/pages/companies/avaloq-f27c1af56d318274a97c83d3308cc22d.png";